const { CHAM_PERSONALIZED_CONTENT_GIG_PAGE } = require('../experimentsEnum');
const { inAbTest } = require('..');

module.exports = (abTests) => inAbTest(abTests, CHAM_PERSONALIZED_CONTENT_GIG_PAGE);
